import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton';

import { HORIZONTAL_PADDING } from './constants';
import { Tracking } from 'bdvp-tracking';

const FONT_SIZE = 24;

const Wrapper = styled.h2`
    margin: 0 ${HORIZONTAL_PADDING.xs}px 20px ${HORIZONTAL_PADDING.xs}px;
    font-family: ${({ theme }) => theme.fonts.family.primary};
    font-size: ${FONT_SIZE}px;
    font-weight: bold;
    line-height: 1;
    ${media.mdmin`
        margin: 0 ${HORIZONTAL_PADDING.md}px 20px ${HORIZONTAL_PADDING.md}px;
    `};
    ${media.lgmin`
        margin: 0 ${HORIZONTAL_PADDING.lg}px 20px ${HORIZONTAL_PADDING.lg}px;
    `};
`;

// "body &" fixes an issue where basesite overrides color in the "a" tag
const Text = styled(Link)`
    color: ${COLORS.mlbWhite};
    body & {
        color: ${COLORS.mlbWhite};
        &:hover {
            color: ${COLORS.mlbWhite};
        }
    }
`;

const Placeholder = styled(Skeleton)`
    min-width: 166px;
    width: 30%;
    height: ${FONT_SIZE}px;
    &:last-child {
        margin-bottom: 0;
    }
`;

const Title = ({
    isLoading,
    title,
    link,
    rank,
}) => {

    const titleComponent = isLoading
        ? <Placeholder />
        : <Text
            to={link}
            onClick={() => Tracking.trackCarouselTitleClick(rank, title)}
        >{title}</Text>;

    return (
        <Wrapper>
            {titleComponent}
        </Wrapper>
    );

};

Title.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    title: PropTypes.string,
    link: PropTypes.string,
    rank: PropTypes.number,
};

Title.defaultProps = {
    title: '',
    link: '',
    rank: 0,
};

export default Title;
